import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

/** Dim backdrop filling its nearest positioned ancestor; pass onClick to close on backdrop click. */
export function Overlay({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden className={cn('absolute inset-0 bg-band/55', className)} {...rest} />;
}
